/**
 * @generated SignedSource<<d1ad3f7b76ca5ffb0b2543b94c3a689d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type RecommendedPagesSpaceBehavior = "HIDDEN" | "SHOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type EndOfPageRecommendation_spaceStatus$data = {
  readonly defaultBehavior: RecommendedPagesSpaceBehavior;
  readonly recommendedPagesEnabled: boolean;
  readonly " $fragmentType": "EndOfPageRecommendation_spaceStatus";
};
export type EndOfPageRecommendation_spaceStatus$key = {
  readonly " $data"?: EndOfPageRecommendation_spaceStatus$data;
  readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_spaceStatus">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EndOfPageRecommendation_spaceStatus",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "recommendedPagesEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "defaultBehavior"
    }
  ],
  "type": "RecommendedPagesSpaceStatus"
};

(node as any).hash = "e2dc5b6313f03efeee343a0956606000";

export default node;
